import { render, staticRenderFns } from "./xfsdph.vue?vue&type=template&id=b7e6a3f2"
import script from "./xfsdph.vue?vue&type=script&lang=js"
export * from "./xfsdph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports